import React, { Component, ReactNode } from 'react';

import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import {
  WithStyles,
  createStyles,
  Link,
  Typography,
  Grid,
  Button,
} from '@material-ui/core';
import { MyPATDialog } from '../common';
import { join } from 'path';

const styles = (theme: Theme) => createStyles({
  customInfoIcon: {
    width: '20px',
    marginLeft: '5px',
    position: 'relative',
    top: '4px',
  },
  tooltip: {
    display: 'inline',
    position: 'relative',
    color: 'rgb(183, 183, 183)',
    fontSize: 16,
    verticalAlign: 'middle',
    padding: '0px 4px',
    '&:hover': {
      color: 'rgba(0, 0, 0, 0.7)',
      textDecoration: 'none'
    }
  },

  okButton: {
    fontFamily: 'Nunito',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: 14,
    lineHeight: '19px',
    letterSpacing: '0.5px',
    color: '#FFFFFF',
    background: '#1D7DEA',
    padding: '4px 22px',
    width: 188,
    borderRadius: 4,
    '&:hover': {
      background: '#1D7DEA'
    }
  },

  knowMoreBtn: {
    background: '#FFFFFF',
    border: '1px solid #1D7DEA',
    color: '#1D7DEA',
    '&:hover': {
      background: '#FFF'
    }
  },

  imageContainer: {
    background: '#E1E1E1',
    border: '1px solid #E1E1E1',
    borderRadius: 4,
    width: 'inherit'
  },

  image: {
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '100%',
    height: '100%',
    zoom: 1.7
  },

  linkButton: {
    verticalAlign: "top-text"
  },

  marginTopSM: {
    marginTop: 10
  },

  marginBottomSM: {
    marginBottom: 24
  },

  paddingSM: {
    padding: '10px 40px 26px'
  },

  tooltipDetails: {
    content: 'asas',
    background: 'rgb(0, 0, 0)',
    borderRadius: 3,
    marginTop: 6,
    padding: '8px 8px',
    whiteSpace: 'nowrap',
    color: '#fff',
    position: 'absolute',
    zIndex: 9999,
    fontFamily: 'Nunito',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: 12,
    lineHeight: '16px',
    letterSpacing: '0.5px',
    textTransform: 'initial',
    opactiy: 0,
    transition: 'opacity .6s',
    textAlign: 'center'
  },

  rightArrow: {
    right: 0
  },

  leftArrow: {
    left: 0
  },

  centerArrow: {
    top: '100%',
    left: '50%',
    marginLeft: -64,
    marginTop: 6
  },

  topArrow: {
    position: 'absolute',
    width: 0,
    height: 0,
    bottom: 0,
    top: 19,
    left: '20%',
    borderLeft: '5px solid rgba(0, 0, 0, 0)',
    borderRight: '5px solid rgba(0, 0, 0, 0)',
    borderBottom: '12px solid rgb(0, 0, 0)'
  },

  tooltipContainer: {
    position: 'relative',
    display: 'inline-flex',
    alignItems: 'center',
  },

  centerTooltip: {
    top: '100%',
    display: 'block'
  },

  topLG: {
    top: '100%'
  },

  bottomLG: {
    bottom: '100%',
    whiteSpace: 'normal',
    textAlign: 'left',
    fontSize: 12,
    lineHeight: '18px'
  },

  borderSM: {
    background: '#FFFFFF',
    border: '1px solid #E1E1E1',
    borderRadius: 4
  },

  paddingXS: {
    padding: '12px 20px'
  },

  paddingMD: {
    padding: 28
  },

  paddingLR: {
    padding: '0px  12px 4px'
  },

  widthSM: {
    width: 600
  },

  widthMD: {
    maxWidth: 800
  },

  widthXS: {
    maxWidth: 523,
  },

  knowMoreFont: {
    fontFamily: 'Nunito',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 16,
    lineHeight: '22px',
    color: 'rgb(51, 51, 51)'
  },
  alignLeft: {
    textAlign: 'left'
  },
  imgFullWidth: {
    margin: '0 auto',
    textAlign: 'center',
    width: '100%'
  },
  contentPara: {
    margin: '0 auto',
    textAlign: 'center',
    width: '100%',
    '& p': {
      textAlign: 'center',
      '& div': {
        textAlign: 'center',
      }
    }
  }
});

//@ts-ignore
interface CustomInfoIconProps extends WithStyles<typeof styles> {
  classes: any,
  details: string,
  toolTipDirection: any,
  isInfoIcon: boolean,
  isRightArrow: boolean,
  isLeftArrow: boolean,
  isCenterArrow: boolean,
  infoDialogContentType: string,
  dialogTitle: string,
  imageURL?: string,
  dialogPara: string,
  htmlElement: ReactNode,
  knowMoreAbout: string,
  componentName: string;
  isClickRequired: boolean; 
  explicitlyShowDialog: boolean;
  dialogCloseCallback: any;
  showTooltip: boolean;
  isHidePhase: boolean;
  hideCloseIconInPopup?: boolean;
}

interface CustomInfoIconState {
  isTooltip: boolean;
  showDialog: boolean;
  showMore: boolean
}

const knowMoreDetail = [
  {
    'name': 'goal',
    'details': {
      'icon_para': 'You can filter out the data based on any Goal->Subject->Sub-Subject->Chapter->Concept and view the results on My Library homepage.',
      'para': 'For example: You can select the goal JEE (A), the results will get filtered based on the goal first. Then Select “Chemistry”, search will keep filtering based on every selection. Select chapter as “Inorganic Chemistry” then select concept as “Chemistry in everyday life”. Final results based on this concept will now be visible in the main section.',
      'bigger_image': '/assets/svg/infoIcon/myLibrary/goal.PNG'
    }
  },

  {
    'name': 'filter',
    'details': {
      'icon_para': 'Click on “Add another filter” to add a new filter. The following pop-up will open:',
      'bigger_image': '/assets/svg/infoIcon/myLibrary/filterDialog.png',
      'para2': 'By default, Content Type and Status will appear open. You can select from these or you can add more filters by clicking on “Add Another Filter”, you can select from the created filters:',
      'bigger_image2': '/assets/svg/infoIcon/myLibrary/addMoreFilter.PNG',
      'para3': 'Once added, you can click on “Apply” and the results will come as filtered on the main page.'
    }
  },

  {
    'name': 'templatesetting',
    'details': {
      'icon_para': 'Click on “Add New Test Type” and fill all the details like Test Duration, Master Test Type and Sections Level.',
      'para2': 'Once done, click on “Create Template” to add a new template.',
      'bigger_image2': '/assets/svg/infoIcon/templateSettings/templateSetting.png',
      'para3': 'Add all the details like Name, Goal, choose the number of sections. As per the number of sections added, add details corresponding to all the sections and click on “Save”. Once done, the template will start appearing in the Template Settings section.',
      'bigger_image3': '/assets/svg/infoIcon/templateSettings/templateSetting2.svg'
    }
  }

];

class CustomInfoIcon extends Component<CustomInfoIconProps, CustomInfoIconState>{
  public static defaultProps = {
		isClickRequired: true,
	};

  constructor(props: CustomInfoIconProps, state: CustomInfoIconState) {
    super();
    this.state = { isTooltip: false, showDialog: false, showMore: false }
  }

  handleMouseHover = () => {
    this.setState({ isTooltip: !this.state.isTooltip });
  }

  handleClick = (event: any) => {
    event.preventDefault();
    this.setState({ showDialog: !this.state.showDialog });
  }

  handleDialogClose = () => {
    const { dialogCloseCallback } = this.props;
    this.setState({ showDialog: !this.state.showDialog, showMore: false }, () => dialogCloseCallback && dialogCloseCallback())
  }

  handleMore = () => {
    this.setState({ showMore: !this.state.showMore })
  }

  renderSwitch(data: any) {
    const { classes } = this.props;
    switch (data.name) {
      case 'filter':
        return (
          <>
            <Grid item>
              <Grid item className={[classes.marginTopSM, classes.paddingMD, classes.imageContainer].join(' ')}>
                <img className={classes.image} src={data.details.bigger_image} alt="favorite" width="100%" /><br />
              </Grid>
              <Typography align="center" variant="body2" component="h3" style={{ padding: '20px 12px 8px' }} className={classes.knowMoreFont}>
                {data.details.para2}
              </Typography>
            </Grid>
            <Grid item className={[classes.marginTopSM, classes.paddingMD, classes.imageContainer].join(' ')}>
              <img className={classes.image} src={data.details.bigger_image2} alt="favorite" width="100%" /><br />
            </Grid>
            <Grid item>
              <Typography align="center" variant="body2" component="h3" style={{ padding: '20px 12px 8px' }} className={classes.knowMoreFont}>
                {data.details.para3}
              </Typography>
            </Grid>
          </>
        );
      case 'templatesetting':
        return (
          <>
            <Grid item className={[classes.marginTopSM, classes.paddingMD, classes.imageContainer].join(' ')}>
              <img className={classes.image} src={data.details.bigger_image2} alt="favorite" width="100%" /><br />
            </Grid>
            <Typography align="center" variant="body2" component="h3" style={{ padding: '20px 12px 8px' }} className={classes.knowMoreFont}>
              {data.details.para2}
            </Typography>
            <Grid item className={[classes.marginTopSM, classes.paddingMD, classes.imageContainer].join(' ')}>
              <img className={classes.image} src={data.details.bigger_image3} alt="favorite" width="100%" /><br />
            </Grid>
            <Grid item>
              <Typography align="center" variant="body2" component="h3" style={{ padding: '20px 12px 8px' }} className={classes.knowMoreFont}>
                {data.details.para3}
              </Typography>
            </Grid>
          </>
        );
      default:
        return (
          <>
            <Grid item>
              <Typography align="center" variant="body2" component="h3" style={{ padding: '20px 12px 8px' }} className={classes.knowMoreFont}>
                {data.details.para}
              </Typography>
            </Grid>
            <Grid item className={[classes.marginTopSM, classes.paddingMD, classes.imageContainer].join(' ')}>
              <img className={classes.image} src={data.details.bigger_image} alt="favorite" width="100%" /><br />
            </Grid>

          </>
        );
    }
  }

  render() {
    const {
      classes,
      details,
      toolTipDirection,
      isInfoIcon,
      isCenterArrow,
      isRightArrow,
      dialogTitle,
      imageURL,
      dialogPara,
      knowMoreAbout,
      componentName,
      explicitlyShowDialog,
      showTooltip,
      infoDialogContentType,
      isClickRequired,
      hideCloseIconInPopup = false,
      htmlElement } = this.props;
    const { isTooltip, showDialog, showMore } = this.state;
    const knowMoreData: any = knowMoreDetail.filter((value: any) => {
      return value.name == componentName;
    })

    return (

      <>
        {isInfoIcon ?
          <span className={classes.tooltipContainer}>
            <Link
              component="button"
              variant="body2"
              onClick={this.handleClick.bind(this)}
              onMouseOver={this.handleMouseHover.bind(this)}
              onMouseOut={this.handleMouseHover.bind(this)}
              classes={{ button: classes.linkButton }}
            >
              <img className={classes.customInfoIcon} src="/assets/svg/infoIcon/info.svg" alt="info" />

              {(isTooltip || showTooltip) &&  <span className={toolTipDirection == 'top' ? classes.topArrow : classes.leftArrow} />}

            </Link>
            {(isTooltip || showTooltip) && 
              <Grid className={[classes.tooltipDetails, (isRightArrow ? classes.rightArrow : classes.leftArrow), isCenterArrow && classes.centerArrow].join(' ')}>
                {details}
              </Grid>
            }
          </span>
          : ''}
        {
          !isInfoIcon && <>
            <Grid className={[classes.tooltipDetails, toolTipDirection == 'bottom' ? classes.bottomLG : classes.topLG, isRightArrow ? classes.rightArrow : classes.leftArrow].join(' ')}>
              {details}
            </Grid>
          </>
        }
        { isClickRequired && <MyPATDialog
          isCloseButtonHidden={hideCloseIconInPopup}
          dialogOpen={explicitlyShowDialog || showDialog}
          dialogHasActions={true}
          dialogHeading={!showMore ? dialogTitle : 'Know more about it'}
          isAlignCenter={true}
          onDialogClose={this.handleDialogClose.bind(this)}
          customButtonVariant="withoutBorderCloseIcon"
          otherDialogProps={{
            fullWidth: false,
            maxWidth: false
          }}
          customDialogActions={
            showMore &&
            <>
              <Grid container justify="center" alignItems="center">
                <Button onClick={this.handleDialogClose.bind(this)} className={classes.okButton}>Ok Got It!</Button>
              </Grid>
            </>
          }
        >
          {!showMore ?
            <>
              <Grid container justify="center" alignItems="center" className={this.props.isHidePhase ? classes.widthXS : classes.widthSM}>
                
                {(imageURL) &&
                  <Grid item className={classes.imgFullWidth}>
                  <img className={classes.marginTopSM} src={imageURL} alt="favorite" />
                </Grid>
                }
                <Grid item className={classes.contentPara}>
                  {(dialogPara !== '') ?
                  <>
                  <Typography variant="body1" align="center" className={classes.paddingSM}>
                    <div className={classes.alignLeft} dangerouslySetInnerHTML={{__html: dialogPara}}></div>
                  </Typography>
                  </>
                :
                  <>
                  <Grid>
                    {htmlElement}
                  </Grid>
                  </>
                  }
                </Grid>
                <Grid item className={[classes.marginTopSM, classes.marginBottomSM].join(' ')}>
                  {knowMoreAbout && <><Button onClick={this.handleMore.bind(this)} className={[classes.okButton, classes.knowMoreBtn].join(' ')}>Know more about it</Button> &nbsp;	&nbsp;	&nbsp;</>}
                  <Button onClick={this.handleDialogClose.bind(this)} className={classes.okButton}>Ok, Got It !</Button>
                </Grid>
              </Grid>
            </>
            :
            <>
              <Grid className={classes.widthMD}>
                <Grid container className={[classes.borderSM, classes.marginTopSM].join(' ')}>
                  
                  {(imageURL) &&
                    <Grid item xs={1} className={[classes.paddingLR, classes.imgFullWidth].join(' ')}>
                    <img className={classes.marginTopSM} src={imageURL} height="50" alt="favorite" />
                  </Grid>
                  }
                  <Grid item xs={11} className={[classes.paddingXS, classes.contentPara].join(' ')}>
                    <Typography className={classes.knowMoreFont} variant="body2" component="h3">
                      <div className={classes.alignLeft} dangerouslySetInnerHTML={{__html: dialogPara}}></div>
                    </Typography>
                  </Grid>
                </Grid>

                <Grid container justify="center" alignItems="center">
                  {this.renderSwitch(knowMoreData[0])}
                </Grid>
              </Grid>
            </>
          }
        </MyPATDialog>
  }
      </>
    );
  }
}

// @ts-ignore
export default withStyles(styles)(CustomInfoIcon);